// Author Lin
// Date 2021-08-16 17:52:43

import * as model from "@/model/sithMes/inventory/SithMesInventoryTransportApplicationModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesInventoryTransportApplication(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_INVENTORY_URL,
        callbackApi: process.env.VUE_APP_SITHMES_INVENTORY_URL + '/sithMesInventoryTransportApplication/workflow/complete-feedback',
        processDefinitionKey: "inventory_transport_application",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
